(() => {
  const SECTION_SELECTOR = '.skullpanda-series-grid';

  const initialize = (section) => {
    if (!section || section.dataset.editorialInitialized === 'true') return;
    const grid = section.querySelector('.skullpanda-series-grid__cards');
    if (!grid) return;

    section.dataset.editorialInitialized = 'true';
    const originalOrder = [...grid.querySelectorAll(':scope > [data-sp-grid-item]')];
    const banners = originalOrder.filter((item) => item.matches('[data-sp-editorial-banner]'));
    if (!banners.length) return;

    const getColumnCount = () => {
      const template = getComputedStyle(grid).gridTemplateColumns;
      return Math.max(1, template.split(' ').filter(Boolean).length);
    };

    const placeBanners = () => {
      const fragment = document.createDocumentFragment();
      originalOrder.forEach((item) => fragment.appendChild(item));
      grid.appendChild(fragment);

      const positioned = banners
        .filter((banner) => banner.dataset.placement !== 'manual')
        .sort((a, b) => Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex));

      positioned.forEach((banner) => {
        const designs = [...grid.querySelectorAll(':scope > [data-sp-design-card]')];
        const method = banner.dataset.placement;
        const requested = method === 'after_row'
          ? Number.parseInt(banner.dataset.afterRow, 10) * getColumnCount()
          : Number.parseInt(banner.dataset.afterItem, 10);
        const itemCount = Number.isFinite(requested) ? Math.max(1, requested) : designs.length;
        const anchor = designs[Math.min(itemCount, designs.length) - 1];
        if (anchor) anchor.after(banner);
        else grid.prepend(banner);
      });
    };

    let resizeFrame;
    const onResize = () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(placeBanners);
    };

    placeBanners();
    window.addEventListener('resize', onResize, { passive: true });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(SECTION_SELECTOR).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
